import React from 'react';
import PropTypes from 'prop-types';

import GenericMenu from 'dpl/path_to_payment/components/GenericMenu';

import FilterButtonActions from './FilterButtonActions';

export default function ExposedFilterDropdown({
  isOpen,
  setIsOpen,
  toggleButton,
  children,
  title,
  totalItemCount,
  resultsType,
  setIsMenuOpen,
  actionsClassName
}) {
  return (
    <div className="relative">
      {toggleButton}
      {isOpen && (
        <GenericMenu
          setIsMenuOpen={setIsOpen}
          className="ExposedFilterDropdownMenu__container mt2 z-max absolute pt5 pb4 ph5-lg left-0"
          closeOnClickOutside
        >
          <p className="mb4 fw-medium font-24 font-serif">{title}</p>
          {children}

          <FilterButtonActions
            className={actionsClassName}
            setIsMenuOpen={setIsMenuOpen}
            totalItemCount={totalItemCount}
            resultsType={resultsType}
          />
        </GenericMenu>
      )}
    </div>
  );
}

ExposedFilterDropdown.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  toggleButton: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  resultsType: PropTypes.string.isRequired,
  totalItemCount: PropTypes.number.isRequired,
  setIsMenuOpen: PropTypes.func.isRequired,
  actionsClassName: PropTypes.string
};

ExposedFilterDropdown.defaultProps = {
  actionsClassName: ''
};
